import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import useIsMobile from "../hooks/useIsMobile";
import useSheetData from "../hooks/useSheetData";
import Reveal from "../components/common/Reveal";
import SectionTag from "../components/common/SectionTag";
import Icon from "../components/common/Icon";
import { SheetLoading, SheetEmpty } from "../components/common/SheetState";
import Seo from "../components/common/Seo";
import { colors, fonts, emphasis, sectionPad, maxW, springHover, rowShift, arrowSlide } from "../styles/theme";
import slugify from "../utils/slugify";

export default function BlogPage() {
  const mob = useIsMobile();
  const { data: posts, status } = useSheetData("Blog");

  return (
    <div style={{ background: colors.paper, minHeight: "100vh", paddingTop: 74 }}>
      <Seo
        title="Blog | Charith"
        description="Insights on cloud strategy, UI/UX design trends, and internship stories from the Charith team."
        path="/blog"
      />
      <section style={{ background: colors.paper, ...sectionPad(mob) }}>
        <Reveal style={{ ...maxW, maxWidth: 720 }}>
          <SectionTag>Insights</SectionTag>
          <h1 style={{ fontFamily: fonts.display, fontWeight: 600, fontSize: mob ? 32 : "clamp(30px,4.2vw,54px)", lineHeight: 1.12, color: colors.ink, letterSpacing: "-.01em" }}>The Charith <span style={emphasis}>Blog</span></h1>
        </Reveal>
      </section>
      <section style={{ background: colors.paper, padding: mob ? "0 6% 56px" : "0 6% 96px" }}>
        {status === "loading" ? (
          <div style={{ maxWidth: 820, margin: "0 auto", textAlign: "center" }}><SheetLoading label="Loading articles…" /></div>
        ) : status === "error" ? (
          <SheetEmpty icon="AlertCircle" title="Couldn't load the blog" message="We're unable to reach our articles right now — please check back shortly." />
        ) : posts.length === 0 ? (
          <SheetEmpty icon="Newspaper" title="No articles yet" message="We haven't published anything yet — check back soon for updates from the team." />
        ) : (
          <div style={{ maxWidth: 820, margin: "0 auto", borderTop: `1px solid ${colors.borderStrong}` }}>
            {posts.map((b, i) => (
              <Reveal key={b.slug || i} delay={i * 0.05}>
                <Link to={`/blog/${b.slug || slugify(b.title)}`} style={{ textDecoration: "none", display: "block" }}>
                  <motion.div initial="rest" whileHover="hover" variants={rowShift} transition={springHover} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 20, padding: mob ? "24px 4px" : "30px 16px", borderBottom: `1px solid ${colors.border}`, cursor: "pointer" }}>
                    <div>
                      <div style={{ display: "flex", gap: 10, marginBottom: 12, flexWrap: "wrap", alignItems: "center" }}>
                        <span style={{ border: `1px solid ${colors.borderStrong}`, color: colors.rust, fontFamily: fonts.body, fontSize: 10.5, fontWeight: 700, padding: "3px 9px", borderRadius: 20 }}>{b.cat}</span>
                        <span style={{ color: colors.inkFainter, fontFamily: fonts.body, fontSize: 12 }}>{b.date} · {b.read} read</span>
                      </div>
                      <h3 style={{ fontFamily: fonts.display, fontWeight: 600, fontSize: mob ? 17 : 21, color: colors.ink, lineHeight: 1.4, maxWidth: 600 }}>{b.title}</h3>
                    </div>
                    {!mob && <motion.span variants={arrowSlide} transition={springHover} style={{ display: "flex", flexShrink: 0 }}><Icon name="ArrowUpRight" size={18} style={{ color: colors.inkFaint }} /></motion.span>}
                  </motion.div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
